import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Row, Spinner, Alert } from '@themesberg/react-bootstrap';
import { ChoosePhotoWidget, ProfileCardWidget } from "../../components/Widgets";
import { GeneralInfoForm } from "../../components/Forms";
import Swal from "sweetalert2";
import api from "../../utils/api";
import { useAuth } from "../../context/AuthContext";
import { Routes } from "../../routes";

export default function EditUser() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch user data
  /* useEffect(() => {
    setLoading(true);
    fetch(`http://localhost:3000/admin/users/${id}`)
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch user");
        return res.json();
      })
      .then(data => {
        setUser(data.data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [id]); */

  useEffect(() => {
    setLoading(true);
    api.get(`/users/${id}`).then(({ data }) => {
      setUser(data.data);
      setLoading(false);
    }).catch((err) => {
      setError(err.message);
    }).finally(() => {
      setLoading(false);
    });
  }, [id]);

  // Handle profile picture change
  const handleProfilePicChange = (file) => {
    setProfilePic(file);
  };

  // Handle form submit
  const handleSubmit = async (formData) => {
    setError(null);
    try {
      let body;
      let headers = {};
      if (profilePic && profilePic instanceof File) {
        body = new FormData();
        Object.entries(formData).forEach(([key, value]) => body.append(key, value));
        body.append("profile_pic", profilePic);
      } else {
        body = JSON.stringify({ ...formData, profile_pic: profilePic });
        headers["Content-Type"] = "application/json";
      }

      const response = await fetch(`http://localhost:3000/admin/users/${id}`, {
        method: "PUT",
        body,
        headers,
      });

      const result = await response.json();
      if (!response.ok || result.error) {
        throw new Error(result.message || "Failed to update user");
      }

      setUser(result.data);
      setProfilePic(result.data.profile_pic || null);

      // ✅ SweetAlert2 Success Popup (keeps scroll working)
      Swal.fire({
        title: "Success 🎉",
        text: "Profile updated successfully!",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
        heightAuto: false,  // important to prevent scroll lock
        willClose: () => {
          document.body.style.overflow = "auto";
          document.documentElement.style.overflow = "auto";
        }
      });

    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!user) return null;

  return (
    <Row>
      <Col xs={12} xl={8}>
        <GeneralInfoForm user={user} onSubmit={handleSubmit} />
      </Col>
      <Col xs={12} xl={4}>
        <Row>
          <Col xs={12}>
            <ProfileCardWidget user={user} profilePic={profilePic} />
          </Col>
          {/* <Col xs={12}>
            <ChoosePhotoWidget
              title="Select profile photo"
              photo={profilePic}
              onPhotoChange={handleProfilePicChange}
            />
          </Col> */}
        </Row>
      </Col>
    </Row>
  );
}
